import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { useUnitSystem, writeUnitSystem } from './units';

// Imperial / metric switch for the dashboard, shown in the Calibration window.
// It flips the account-wide unit setting (the same one in Settings), so other
// pages follow.
function UnitsToggle({ size = 'small' }) {
  const system = useUnitSystem();
  return (
    <Tooltip title='Units for the whole dashboard. Also changes your account setting.' arrow>
      <ToggleButtonGroup
        value={system}
        exclusive
        size={size}
        aria-label='Units'
        onChange={(e, val) => { if (val) writeUnitSystem(val); }}
        onClick={(e) => e.stopPropagation()}
        sx={{
          flexShrink: 0,
          '& .MuiToggleButton-root': { py: 0.25, px: 1, fontSize: 12, textTransform: 'none', whiteSpace: 'nowrap' },
        }}
      >
        <ToggleButton value='imperial' aria-label='Imperial units: inches, kips, feet'>in · kips</ToggleButton>
        <ToggleButton value='metric' aria-label='Metric units: millimetres, kilonewtons, metres'>mm · kN</ToggleButton>
      </ToggleButtonGroup>
    </Tooltip>
  );
}

export default UnitsToggle;
